import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import ReactGA from 'react-ga';
import en from '../../../assets/images/billboard-en-cards.png';
import pt from '../../../assets/images/billboard-pt-cards.png';

const propTypes = {
  locale: PropTypes.string.isRequired,
};

const Billboard = ({ locale }) => {
  let img;
  switch (locale) {
    case 'pt':
      img = pt;
      break;
    default:
      img = en;
  }

  const handleClick = () => {
    ReactGA.event({
      category: 'Ads',
      action: 'Clicou em Banner Topo (Billboard)',
    });
  };

  return (
    <div className="billboard row">
      <div className="computer only tablet only column">
        <Link
          onClick={handleClick}
          to="http://www.cards-expo.com.br"
          target="_blank" rel="noreferrer noopener"
        >
          <img src={img} alt="Cabeçalho" className="ui banner fluid image" />
        </Link>
      </div>
    </div>
  );
};

Billboard.propTypes = propTypes;

export default Billboard;



/** WEBPACK FOOTER **
 ** ./src/components/layout/ads/Billboard.js
 **/